import queryString from "query-string";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";

import { useAxios, useComponent } from "../../hooks";
import {
  companyObject,
  objectFromResponseData,
} from "./company details components/companyDetailsObject";
import Form from "./company details components/Form";
import { Loader } from "../../components";

export default function CompanyDetails({ withCompany }) {
  const axios = useAxios();
  const { loader } = useComponent();
  let ID = "";

  const { agency } = useSelector((state) => state.memberDetails);
  const brandID =
    useSelector((state) => state.memberDetails?.activeBrand.ID) ||
    queryString.parse(window.location.search).brandID ||
    sessionStorage.getItem("brandID");

  const agencyID =
    useSelector((state) => state.memberDetails?.agencyID) ||
    queryString.parse(window.location.search).agencyID ||
    sessionStorage.getItem("agencyID");

  const role = sessionStorage.getItem("role");

  const details =
    queryString.parse(window.location.search).withCompany || withCompany;

  const [formData, setFormData] = useState(companyObject);

  if (role === "NORMAL_USER" && brandID) {
    if (agencyID && Object.keys(agency).length > 0) {
      ID = agencyID;
    } else {
      ID = brandID;
    }
  }

  if (role === "AGENCY" && agencyID) {
    ID = agencyID;
  }

  const [editState, setEditState] = useState(true);

  useEffect(() => {
    loader.start(1);
    if (!!details) {
      setEditState(false);
    }

    if (details) {
      axios({
        url: "/getCompany/" + ID + "?type=" + role,
      }).then((response) => {
        if (response.status) {
          setFormData(objectFromResponseData(response.data));
          if (response.data.is_brand_verified === 1) {
            setEditState(false);
          }

          if (response.data.is_agency_verified === 1) {
            setEditState(false);
          }
          loader.stop();
        } else {
          loader.stop();
        }
      });
    } else {
      loader.stop();
    }
  }, [axios, details, brandID, loader, ID, role]);

  return (
    <Loader>
      <Form
        agencyID={agencyID}
        brandID={brandID}
        ID={ID}
        formData={formData}
        setFormData={setFormData}
        setEditState={setEditState}
        editState={editState}
      />
    </Loader>
  );
}
